module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"p9s3titles":[{"titleS":true,"title":"Opinions"},{"titleS":false,"title":"about AICAD Business School"}]},"es":{"p9s3titles":[{"titleS":true,"title":"Opiniones"},{"titleS":false,"title":"sobre AICAD Business School"}]}}')
  delete Component.options._Ctor
}
